import React from "react";
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Load } from "../components/load/Load";
import {appUrls} from "../constants/appUrls";

const ProtectedRoutes = ({ isAuth, right, ROUTES, authInProcess = false }) => {
  const location = useLocation();

  if (authInProcess) {
    return <Load />;
  }

  if (!isAuth) {
    return <Navigate to={appUrls.login} state={{ from: location }} replace />;
  }

  return (
    <Routes>
      {ROUTES.map(({ component: Component, path, rights, exact }, index) => {
        if (rights.includes(right)) {
          return (
            <Route
              key={index}
              path={path}
              element={<Component />}
            />
          );
        }
        return null;
      })}
    </Routes>
  );
};

export default ProtectedRoutes;